var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { jsx, jsxs } from "react/jsx-runtime";
import { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { setTheme } from "./../store/reducers/themeReducer.js";
import { Flex, Switch, Select } from "antd";
import { ReactComponent as ContactUsIcon } from "./../assets/icons/contact-us.svg";
import { ReactComponent as MoonIcon } from "./../assets/icons/moon.svg";
import { ReactComponent as FlagIcon } from "./../assets/icons/flag.svg";
import useLocale from "./useLocale";
import useTranslation from "./useTranslation";
import { EVENT_ACTIONS, track } from "./../lib/gtag.js";
const useBurgerMenu = ({
  callback,
  menuItems = [],
  showSelectLanguage = true
} = {}) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const themeMode = useSelector((state) => {
    var _a;
    return (_a = state.theme) == null ? void 0 : _a.mode;
  }) || "dark";
  useEffect(() => {
    setLoading(false);
    setTimeout(() => callback == null ? void 0 : callback(false), 300);
  }, [themeMode]);
  const handleToggle = useCallback(() => {
    setLoading(true);
    setTimeout(() => {
      const next = themeMode === "dark" ? "light" : "dark";
      track(
        next === "dark" ? EVENT_ACTIONS.SETTINGS_SWITCH_THEME_DARK : EVENT_ACTIONS.SETTINGS_SWITCH_THEME_LIGHT
      );
      dispatch(setTheme(next));
    }, 0);
  }, [dispatch, themeMode]);
  const onContactUsClick = () => {
    track(EVENT_ACTIONS.SETTINGS_CONTACT_US);
    callback == null ? void 0 : callback(false);
  };
  const { locale, setLocale, supported } = useLocale();
  const { t } = useTranslation();
  const items = useMemo(
    () => [
      ...menuItems.map((item) => __spreadProps(__spreadValues({}, item), {
        key: `${item.key} disable-redirection`,
        onClick: () => callback == null ? void 0 : callback(false)
      })),
      {
        label: /* @__PURE__ */ jsxs(
          Link,
          {
            to: "/contact-us",
            onClick: onContactUsClick,
            style: {
              display: "flex",
              alignItems: "center",
              gap: 12
            },
            children: [
              /* @__PURE__ */ jsx(
                ContactUsIcon,
                {
                  style: { width: 24, height: 24 },
                  className: "stroke-base"
                }
              ),
              t("contact_us")
            ]
          }
        ),
        key: "contact-us disable-redirection"
      },
      {
        label: /* @__PURE__ */ jsxs(
          Flex,
          {
            align: "center",
            justify: "space-between",
            onClick: handleToggle,
            children: [
              /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 12, children: [
                /* @__PURE__ */ jsx(
                  MoonIcon,
                  {
                    style: { width: 24, height: 24 },
                    className: "stroke-base"
                  }
                ),
                t("dark_mode")
              ] }),
              /* @__PURE__ */ jsx(
                Switch,
                {
                  checked: themeMode === "dark",
                  loading
                }
              )
            ]
          }
        ),
        key: "dark-mode disable-redirection"
      },
      showSelectLanguage && {
        label: /* @__PURE__ */ jsxs(Flex, { align: "center", justify: "space-between", children: [
          /* @__PURE__ */ jsxs(Flex, { align: "center", gap: 12, children: [
            /* @__PURE__ */ jsx(
              FlagIcon,
              {
                style: { width: 24, height: 24 },
                className: "stroke-base"
              }
            ),
            t("language")
          ] }),
          /* @__PURE__ */ jsx(
            Select,
            {
              value: locale,
              onChange: (val) => setLocale(val),
              bordered: false,
              options: supported.map((s) => ({
                label: s === "en" ? t("english") : s === "ru" ? t("russian") : s === "es" ? t("spanish") : t("portuguese"),
                value: s
              }))
            }
          )
        ] }),
        key: "language disable-redirection"
      }
    ],
    [
      themeMode,
      loading,
      handleToggle,
      locale,
      setLocale,
      showSelectLanguage
    ]
  );
  return { items };
};
var stdin_default = useBurgerMenu;
export {
  stdin_default as default
};
